// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Product_pageContent__Xvx4F","leftSidePane":"Product_leftSidePane__3JFlu","contentContainer":"Product_contentContainer__1R_km"};